module.exports = __webpack_public_path__ + "static/media/onehundredassists.0f4daa7a.jpg";